import { render, staticRenderFns } from "./PositivacaoCliente.vue?vue&type=template&id=98211d4e&scoped=true&"
import script from "./PositivacaoCliente.vue?vue&type=script&lang=js&"
export * from "./PositivacaoCliente.vue?vue&type=script&lang=js&"
import style0 from "./PositivacaoCliente.vue?vue&type=style&index=0&id=98211d4e&scoped=true&lang=css&"
import style1 from "./PositivacaoCliente.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98211d4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
